import { setHeaders } from "../../utils/fetch";

const getters = {
  messages: state => state.messages
};

const actions = {
  createMessage(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/chat`, {
        method: "post",
        headers: setHeaders(
          {
            "Content-Type": "application/json"
          },
          context.getters.user
        ),
        body: JSON.stringify(data)
      })
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          data.editable = true;
          context.commit("addMessage", data);
          resolve();
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },
  deleteMessage(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/chat`, {
        method: "delete",
        headers: setHeaders(
          {
            "Content-Type": "application/json"
          },
          context.getters.user
        ),
        body: JSON.stringify(data)
      })
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("removeMessage", data.id);
          resolve();
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },
  loadChat(context, id) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/chat/${id}`,
        {
          method: "get",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          )
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setMessages", data);
          resolve(data);
        })
        .catch(e => {
          context.commit("setMessages", []);
          console.error(e);
          reject();
        });
    });
  }
};

const mutations = {
  setMessages(state, messages) {
    state.messages = messages;
  },
  addMessage(state, message) {
    state.messages.push(message);
  },
  removeMessage(state, id) {
    state.messages = state.messages.filter(message => {
      return message.id !== id;
    });
  }
};

export default {
  state: initializeState(),
  mutations,
  actions,
  getters
};

function initializeState() {
  return {
    messages: []
  };
}
